<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="p-fluid">
  <app-header icon="fas fa-palette" text="Farben"></app-header>
  <div class="grid">
    <app-colorset-dropdown
      [colSize]="5"
      formControlName="colorset"></app-colorset-dropdown>
  </div>

  <p-divider />
  <app-header
    text="Sortierung"
    icon="fas fa-arrow-down-wide-short"></app-header>
  <div formGroupName="sort" class="grid">
    <app-form-field-wrapper
      [floatingLabel]="false"
      [hideLabel]="true"
      [name]="'enable'"
      [colSize]="12">
      <p-checkbox
        formControlName="enable"
        [binary]="true"
        label="Sortierung anpassen"></p-checkbox>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Sortieren'"
      [hideLabel]="true"
      [floatingLabel]="false"
      [name]="'property'"
      [styleClass]="!form.value.sort.enable ? 'disabled' : ''"
      [colSize]="4">
      <div class="field-checkbox">
        <p-radioButton
          inputId="pie_sort_label"
          value="label"
          formControlName="property" />
        <label for="pie_sort_label" class="ml-2"> Gruppe </label>
      </div>
      <div class="field-checkbox">
        <p-radioButton
          inputId="pie_sort_value"
          value="value"
          formControlName="property" />
        <label for="pie_sort_value" class="ml-2"> Wert </label>
      </div>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Auf-/ Absteigend'"
      [name]="'direction'"
      [styleClass]="!form.value.sort.enable ? 'disabled' : ''"
      [hideLabel]="true"
      [floatingLabel]="false"
      [colSize]="4">
      <div class="field-checkbox">
        <p-radioButton
          inputId="pie_direction_asc"
          value="asc"
          formControlName="direction" />
        <label for="pie_direction_asc" class="ml-2"> aufsteigend </label>
      </div>
      <div class="field-checkbox">
        <p-radioButton
          inputId="pie_direction_desc"
          value="desc"
          formControlName="direction" />
        <label for="pie_direction_desc" class="ml-2"> absteigend </label>
      </div>
    </app-form-field-wrapper>
  </div>
  <p-divider />

  <app-header icon="fas fa-a" text="Beschriftung"></app-header>
  <app-form-field-wrapper
    [hideLabel]="true"
    [floatingLabel]="false"
    [name]="'displayValues'"
    [colSize]="6">
    <p-checkbox
      [binary]="true"
      label="Werte einblenden"
      name="displayValues"
      formControlName="displayValues"></p-checkbox>
  </app-form-field-wrapper>

  <p-divider />
  <app-header icon="fas fa-circle-dot" text="Darstellungsform"></app-header>
  <div class="grid">
    <div class="col-6">
      <app-ngx-slider
        labelCeil="Ring"
        labelFloor="Kreis"
        [options]="pieSliderOptions"
        formControlName="innerRadius"></app-ngx-slider>
    </div>
  </div>
</form>
